import getAFSEvars from "./getAFSEvars";
import getRestockingEvar from "./getRestockingEvar";
import getEarlyAccessEvar from "./getEarlyAccessEvar";

const getSingleItemEvarsString = ({
  sourceId,
  sellerId,
  isProductInStock,
  isRestockingSoon,
  earlyAccess
}) => {
  const eVarStrings = [
    ...getAFSEvars({ sourceId, sellerId }),
    ...getRestockingEvar({ isProductInStock, isRestockingSoon }),
    ...getEarlyAccessEvar({ earlyAccess })
  ];

  return eVarStrings.join("|");
};

export default getSingleItemEvarsString;
